<div class="w-100 d-flex justify-content-center position-absolute"
     style="bottom: 2rem" *ngIf="show">
  <div
    [class]="'alert-flutuante' + (tipoAlerta ? '-' + tipoAlerta : '')">
    <div class="d-flex justify-content-center align-items-center align-content-center">
      <img src="assets/imgs/icones/info-vermelho.svg" alt="">
      <p class="ms-2 mb-0">
        {{texto}}
      </p>
      <img src="assets/imgs/icones/close-vermelho.svg" class="ms-2 cursor-pointer"  alt="" (click)="show = false">
    </div>
  </div>
</div>
